import { NgIf } from '@angular/common';
import { Component, forwardRef, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { AddActivityFormComponent } from '@curbnturf/activity-component/src/lib/add-activity-form/add-activity-form.component';
import { ActivityLocationFacade } from '@curbnturf/activity/src/lib/+state/activity.facade';
import { ActivityLocation, HelperFunctions } from '@curbnturf/entities';
import { IonicModule, NavController } from '@ionic/angular';
import { Subscription } from 'rxjs';

const buildActivityRoute = HelperFunctions.buildActivityRoute;

@Component({
  selector: 'curbnturf-activity-edit-page',
  templateUrl: './activity-edit-page.component.html',
  styleUrls: ['./activity-edit-page.component.scss'],
  standalone: true,
  imports: [
    forwardRef(() => AddActivityFormComponent),
    IonicModule,
    RouterModule,
    NgIf,
  ],
})
export class ActivityEditPageComponent implements OnDestroy, OnInit {
  selectedActivity?: ActivityLocation;

  private subscriptions: Subscription[] = [];

  constructor(
    private activityLocationFacade: ActivityLocationFacade,
    private navController: NavController,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.activityLocationFacade.selected$.subscribe((selectedActivity) => (this.selectedActivity = selectedActivity)),
      this.route.params.subscribe((params) => {
        const id = parseInt(params.id, 10);
        this.activityLocationFacade.load(id);
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  saved() {
    if (this.selectedActivity) {
      this.navController.navigateForward(buildActivityRoute(this.selectedActivity));
    }
  }
}
